import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { ButtonLink } from '@packages/shared/src/ui/Button/Button';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { messages } from './messages';
import { useShopfinderUrl } from './useShopfinderUrl';

export const ReplaceComponent = ({
  index,
  placeholderText,
}: {
  index: number;
  placeholderText: string;
}) => {
  const { formatMessage } = useIntl();
  const [stateOpen, setStateOpen] = useState<boolean>(false);

  return (
    <span key={index}>
      <ButtonLink className="cursor-pointer underline" onClick={() => setStateOpen(true)}>
        {placeholderText}
      </ButtonLink>
      <Dialog isOpen={stateOpen} onClose={() => setStateOpen(false)}>
        <DialogHeader onClose={() => setStateOpen(false)}>
          {formatMessage(messages.headline)}
        </DialogHeader>
        <DialogContent>
          <iframe
            title={formatMessage(messages.iFrameTitle)}
            width="100%"
            height="600"
            style={{ border: 0, overflow: 'hidden' }}
            src={useShopfinderUrl()}
          />
        </DialogContent>
      </Dialog>
    </span>
  );
};
